import Vue from 'vue';
import { axiosSwagger } from "@/axios";
import _cloneDeep from 'lodash/cloneDeep';



export const state = {
    breadCrumb: {
        loading: false,
        data: [],
    },
    modifyBreadCrumb: {
        loading: false,
        data: [],
    },
}


export const getters = {
}


export const mutations = {
    // BREADCRUMB
    breadCrumbLoading: (state, loading) => {
        state.breadCrumb.loading = loading;
    },
    setBreadCrumbData: (state, data) => {
        state.breadCrumb.data = updateBreadCrumbData( data );

        // modify breadcrumbs
        const copyBreadcrumbData =  _cloneDeep(state.breadCrumb.data);
        state.modifyBreadCrumb.data = modifiedBreadCrumb(copyBreadcrumbData);
    },
    setMyBreadCrumb: (state, data) => {
        if(data === null){
            state.breadCrumb.data, state.modifyBreadCrumb.data = [
                {
                    id: 0,
                    text: "My Location",
                    to: { name: "My Location" },
                }
            ]
        }
    }
}


export const actions = {
    // Get File Location by Id
    async readLocationPathById({ commit }, id) {
        commit("breadCrumbLoading", true);

        return await getAllPath(id)
            .then(() => {
                commit("setBreadCrumbData", _path);
                _path = []; // reset path
            })
            .catch(() => {
                commit("breadCrumbLoading", false);
            });
    },
}


let _path = [];
async function getAllPath(id) {

    await axiosSwagger
        .get(`/api/FileLocation/${id}`)
        .then(async (response) => {
            _path.unshift(response.data);

            if(response.data.parentId !== null){
                await getAllPath(response.data.parentId);
            }
            else{
                return _path;
            }
        })
        .catch(() => {
            throw("error getAllPath");
        })
}



const updateBreadCrumbData = (data) => {
    if(data?.length ?? false){
        let _finalData = [
            {
                id: 0,
                text: "My Location",
                to: { name: "My Location" },
            }
        ];

        data.forEach(e => {
            let encryptId = Vue.prototype.$encryptRouteID(e.id.toString());

            _finalData.push({
                id: e.id,
                text: e.location,
                to: {
                    name: 'Location ID',
                    params: { id: encryptId }
                }
            })
        });

        return _finalData;
    }
}



const modifiedBreadCrumb = (data) => {
    if(data.length >= 4){
      const sliceData = data.slice(1, data.length-2);
  
      data.splice(1, data.length-3, sliceData);
      
      return data;
    }
  
    return data;
  };